import { render } from "./rentalContractSubmit.vue?vue&type=template&id=13f6a53b&ts=true"
import script from "./rentalContractSubmit.vue?vue&type=script&lang=ts"
export * from "./rentalContractSubmit.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__